export default __webpack_public_path__ + "static/event-map-1cc41e229a9cb30c4ca2843f9fac83c7.svg";